'use client';

import React from 'react';
import { useGetSiteOfCareTypesQuery } from 'src/api/redux';
import { formatSocClassification } from 'src/components/Profiles/components/ProfileDetails/socTypes';

const SiteOfCareTypeCell = ({ row }) => {
  const { data: taxonomy } = useGetSiteOfCareTypesQuery();
  const label = formatSocClassification(row, taxonomy) || 'n/a';

  return (
    <span className="line-clamp-2 text-sm text-secondary">
      {label}
    </span>
  );
};

export default SiteOfCareTypeCell;
